import * as React from 'react';
import styled from "styled-components";

const SProverb = styled.div`
  flex: 1; /* Allows main content to take up the remaining horizontal space */
  padding: 5px 20px;
`;

const Proverb = () => {
  return (
    <SProverb>
      <h5>Przysłowia</h5>
<br/>
<b>Apetyt rośnie w miarę jedzenia.</b><br/>
Comiendo entra la gana.<br/><br/>

<b>Czas leczy rany.</b><br/>
El tiempo lo cura todo.<br/>
El tiempo restaura las heridas.<br/><br/>

<b>Co nagle, to po diable.</b><br/>
Aprisa y bien no puede ser.<br/><br/>

<b>Czego oczy nie widzą, tego sercu nie żal.</b><br/>
Lo que de los ojos no está cerca, del corazón se aleja.<br/>
Ojos que no ven, corazón que no siente.<br/><br/>

<b>Darowanemu koniowi nie patrzy sie w zęby.</b><br/>
A caballo regalado, no le mires el diente.<br/><br/>

<b>Do tanga trzeba dwojga.</b><br/>
Cuando uno no quiere, dos no barajan.<br/><br/>

<b>Dobra mina do złej gry.</b><br/>
A mal tiempo buena cara.<br/><br/>

<b>Drzewo poznasz po jego owocach.</b><br/>
El árbol por el fruto es conocido.<br/><br/>

<b>Kłamstwo ma krótkie nogi.</b><br/>
La mentira no tiene pies.<br/><br/>

<b>Kropla drąży skały.</b><br/>
Agua blanda en dura piedra tanto dará que la hienda.<br/>
La gota de agua horada la piedra.<br/><br/>

<b>Krowa, która głośno ryczy, mało mleka daje.</b><br/>
Perro ladrador nunca es buen mordedor.<br/>
Perro ladrador, poco mordedor.<br/>
Perro que ladra no muerde.<br/><br/>

<b>Kto mieczem wojuje, ten od miecza ginie.</b><br/>
Quien a hierro mata, a hierro muere.<br/><br/>

<b>Kto nie pracuje, ten nie je.</b><br/>
El que no trabaje, que no coma.<br/>
En esta vida caduca el que no trabaja no manduca.<br/><br/>

<b>Kto rano wstaje, temu Pan Bóg daje.</b><br/>
A quien madruga Dios le ayuda.<br/>
El que madruga coge la oruga.<br/><br/>

<b>Kuj żelazo póki gorące.</b><br/>
A la ocasion la pintan calva.<br/><br/>

<b>Lepiej późno niż wcale.</b><br/>
Más vale tarde que nunca.<br/><br/>

<b>Lepiej zapobiegać niż leczyć.</b><br/>
Más vale un "por si acaso" que un "quien pensara".<br/><br/>

<b>Lepszy wróbel w garści, niż gołąb na dachu.</b><br/>
Más vale pájaro en mano que buitre volando.<br/>
Más vale pájaro en mano que ciento volando.<br/><br/>

<b>Miłość jest ślepa.</b><br/>
Afición ciega razón.<br/><br/>

<b>Mowa jest srebrem, a milczenie złotem.</b><br/>
En boca cerrada no entran moscas.<br/>
Antes de hablar, un padrenuestro rezar.<br/><br/>

<b>Nie ma dymu bez ognia.</b><br/>
Donde fuego se hace, humo sale.<br/>
Donde hay humo, hay calor.<br/><br/>

<b>Nie ma róży bez kolców.</b><br/>
No hay rosa sin espinas.<br/><br/>

<b>Nie od razu Rzym zbudowano.</b><br/>
No se ganó Toledo en un credo.<br/>
No se ganó Zamora en una hora.<br/><br/>

<b>Nie przekonasz się dopóki nie spróbujesz.</b><br/>
No se sabe si algo es bueno hasta que se lo pone a prueba.<br/><br/>

<b>Nie wszystko złoto co się świeci.</b><br/>
No es oro todo que reluce.<br/><br/>

<b>Nikt nie jest prorokiem we własnej ojczyźnie.</b><br/>
En su tierra, ningún profeta es acepto.<br/><br/>

<b>O gustach się nie dyskutuje.</b><br/>
Sobre gustos no hay disputa.<br/>
Sobre gustos y colores no discuten los doctores no han escrito los autores.<br/>
Sobre gustos, no hay nada escrito.<br/><br/>

<b>Okazja czyni złodzieja.</b><br/>
La ocasión hace un ladrón.<br/><br/>

<b>Pióro mocniejsze jest od miecza.</b><br/>
Mas puede la pluma que la espada.<br/><br/>

<b>Po burzy zawsze wychodzi słońce.</b><br/>
Nie ma tego złego co by na dobre nie wyszło.<br/>
Tras tormenta, gran bonanza.<br/>
Después de la lluvia viene el buen tiempo.<br/>
Tras la lluvia viene el sol.<br/>
No hay mal que por bien no venga.<br/><br/>

<b>Po nitce do kłębka.</b><br/>
Por el hilo sacarás el ovillo.<br/><br/>

<b>Praca nie zając, nie ucieknie.</b><br/>
No por mucho madrugar amanece más temprano.<br/><br/>

<b>Przyjaciół poznaje się w biedzie.</b><br/>
En las malas se conocen a los amigos.<br/><br/>

<b>Ręka rękę myje.</b><br/>
Un cuchillo afila otro.<br/><br/>

<b>Spocząć na laurach.</b><br/>
Cría buena fama y échate a dormir.<br/><br/>

<b>Szewc bez butów chodzi.</b><br/>
En casa del herrero, cuchara/cuchillo de palo.<br/>
En casa de carpintero, puerta de cuero.<br/><br/>

<b>Śpiesz się powoli.</b><br/>
Despacito se va lejos.<br/><br/>

<b>Ten się śmieje, kto się śmieje ostatni.</b><br/>
Ríe bien el que ríe el último.<br/><br/>

<b>To tak, jakby mówić do ściany.</b><br/>
Es como hablar a la pared.<br/><br/>

<b>Umarł król, niech żyje król.</b><br/>
A rey muerto, rey puesto.<br/><br/>

<b>Ziarnko do ziarnka a zbierze się miarka.</b><br/>
A quien cuida la peseta nunca le falta un duro.<br/><br/>

<b>Zakazany owoc smakuje najbardziej.</b><br/>
Es más dulce el sabor de la fruta robada.<br/>
Mucho más se desea lo que se veda.<br/><br/>

<b>Złego licho nie weźmie.</b><br/>
Hierba mala nunca muere.
    </SProverb>
  )
};

export default Proverb;